"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateWithCorrectFormat = exports.getPunchesTimeSegmentsOnDate = exports.getHourlyBreakdownsByDate = exports.HourlyBreakdownFeature = void 0;
const luxon_1 = require("luxon");
const react_1 = __importStar(require("react"));
const HourlyBreakdown_1 = require("../../components/HourlyBreakdown");
const hooks_1 = require("../../hooks");
const DateManagement_1 = require("../../utils/DateManagement");
const TAAErrorBoundary_1 = require("../../components/Shared/TAAErrorBoundary");
const consts_1 = require("../../consts");
const contexts_1 = require("../../contexts");
const logger_1 = require("../../logger");
const TIME_SEGMENT_DATE_FORMAT = 'M/dd/yyyy';
const HourlyBreakdownFeature = ({ selectedDateTime, selectedDate, timeRange, featureGates, isInTimecard = false }) => {
    const { associateInfo } = (0, contexts_1.useTaaConfigsContext)();
    const [isFirstRender, setIsFirstRender] = (0, react_1.useState)(true);
    const usageLocation = consts_1.featureNames.HOURLY_BREAKDOWN_FEATURE;
    const { canDeleteDuplicatePunch = false, isSelfClassificationEnabled = false, isATPlusSelfClassificationEnabled = false, isATPlusTemporalRoutingEnabled = false } = featureGates;
    const { selectedDate: taaSelectedDate, timeRange: taaTimeRange } = (0, hooks_1.useDateQueryParams)(selectedDateTime);
    if (selectedDateTime) {
        selectedDate = taaSelectedDate;
        timeRange = taaTimeRange;
    }
    const { isLoading: isPunchLoading, data: { punchesTimeSegments, timeSegmentDailyAggregation } = {} } = (0, hooks_1.usePunches)({
        employeeId: associateInfo.employeeId,
        timeRange,
        isEligibilityEnabled: !!canDeleteDuplicatePunch,
        usageLocation,
        temporalRouting: isATPlusTemporalRoutingEnabled
    });
    const hourlyBreakdownsByDate = (0, react_1.useMemo)(() => (0, exports.getHourlyBreakdownsByDate)(timeSegmentDailyAggregation, featureGates), [timeSegmentDailyAggregation]);
    const punchesTimeSegmentsOnSelectedDate = (0, react_1.useMemo)(() => (0, exports.getPunchesTimeSegmentsOnDate)(punchesTimeSegments, selectedDate), [punchesTimeSegments, selectedDate]);
    const propsWithoutSelfClassification = {
        commonProps: {
            hourlyBreakdownsBySite: hourlyBreakdownsByDate[selectedDate.toFormat(TIME_SEGMENT_DATE_FORMAT)],
            punchesTimeSegments: punchesTimeSegmentsOnSelectedDate,
            selectedDate,
            featureGates,
            isLoading: !!isPunchLoading,
            isInTimecard
        },
        selfClassificationProps: undefined
    };
    const hourlyBreakdownProps = (0, hooks_1.useSelfClassification)({
        employeeId: associateInfo.employeeId,
        selectedDate,
        timeZone: associateInfo.timeZone,
        punchesTimeSegments: punchesTimeSegmentsOnSelectedDate,
        hourlyBreakdownProps: propsWithoutSelfClassification,
        isSelfClassificationEnabled: isSelfClassificationEnabled,
        isATPlusSelfClassificationEnabled: isATPlusSelfClassificationEnabled,
        usageLocation
    });
    (0, logger_1.useComponentLoadedMetrics)({
        metricNames: {
            countMetricName: logger_1.METRICS.HOURLY_BREAKDOWN_FEATURE.COUNT,
            latencyMetricName: logger_1.METRICS.HOURLY_BREAKDOWN_FEATURE.LATENCY
        },
        isComponentLoaded: !hourlyBreakdownProps.commonProps.isLoading,
        isFirstRenderState: { isFirstRender, setIsFirstRender }
    });
    return (react_1.default.createElement(TAAErrorBoundary_1.TAAErrorBoundary, null,
        react_1.default.createElement(HourlyBreakdown_1.HourlyBreakdown, Object.assign({}, hourlyBreakdownProps))));
};
exports.HourlyBreakdownFeature = HourlyBreakdownFeature;
const getHourlyBreakdownsByDate = (timeSegments, featureGates) => {
    const hourlyBreakdownsByDate = {};
    timeSegments === null || timeSegments === void 0 ? void 0 : timeSegments.forEach(({ date, amountInMinutes, amount, unit, timeSegmentTypeId, timeSegmentDescription, sites }) => {
        const dateKey = (0, exports.getDateWithCorrectFormat)(date);
        const dailyHourlyBreakdownsBySite = hourlyBreakdownsByDate[dateKey] || {};
        const siteId = sites.sort().join(', ');
        hourlyBreakdownsByDate[dateKey] = Object.assign(Object.assign({}, dailyHourlyBreakdownsBySite), { [siteId]: [
                ...(dailyHourlyBreakdownsBySite[siteId] || []),
                {
                    payCode: (featureGates === null || featureGates === void 0 ? void 0 : featureGates.isSelfClassificationEnabled)
                        ? timeSegmentDescription
                        : timeSegmentTypeId,
                    amountInMinutes,
                    amount,
                    unit
                }
            ] });
    });
    return hourlyBreakdownsByDate;
};
exports.getHourlyBreakdownsByDate = getHourlyBreakdownsByDate;
const getPunchesTimeSegmentsOnDate = (punchesTimeSegments, selectedDate) => {
    var _a;
    const punchesTimeSegmentsOnSelectedDate = (_a = punchesTimeSegments === null || punchesTimeSegments === void 0 ? void 0 : punchesTimeSegments.filter(({ startDateTime, endDateTime }) => {
        const punchDate = startDateTime !== null && startDateTime !== void 0 ? startDateTime : endDateTime;
        return (0, DateManagement_1.areDatesEqual)(selectedDate, luxon_1.DateTime.fromISO(punchDate));
    })) !== null && _a !== void 0 ? _a : [];
    return punchesTimeSegmentsOnSelectedDate;
};
exports.getPunchesTimeSegmentsOnDate = getPunchesTimeSegmentsOnDate;
const getDateWithCorrectFormat = (dateStr) => {
    return luxon_1.DateTime.fromFormat(dateStr, TIME_SEGMENT_DATE_FORMAT).toFormat(TIME_SEGMENT_DATE_FORMAT);
};
exports.getDateWithCorrectFormat = getDateWithCorrectFormat;
